module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f3af.1bd68557.svg";